import { useState } from "react";
import { format } from "date-fns";
import Box from "@mui/material/Box";
import Paper from "@mui/material/Paper";
import MuiDatePicker from "../../../Common/FormInputs/MuiDatePicker";
import AppButton from "../../../Common/Button/Button";
import Alert from "../../../layout/Alert";
import { SectionHeading, LabelText } from "../../../Common/Typography/AppTypography";

const fieldWrapperSx = { mb: { xs: 1, sm: 2 } };
const labelTopSx = { mb: 1, display: "block", fontWeight: 500 };

const DACCount = ({ dacData, getDACCount }) => {
    const [startDateFilter, setStartDateFilter] = useState(null);
    const [endDateFilter, setEndDateFilter] = useState(null);
    const [showDACData, setShowDACData] = useState(false);

    const handleStartDateChange = (date) => {
        setStartDateFilter(date ? date.getTime() : null);
        setEndDateFilter(null);
        setShowDACData(false);
    };

    const handleEndDateChange = (date) => {
        setEndDateFilter(date ? date.getTime() : null);
        setShowDACData(false);
    };

    const filter = () => {
        setShowDACData(false);
        const startDate = format(new Date(Number(startDateFilter)), "dd-MM-yyyy");
        const endDate = format(new Date(Number(endDateFilter)), "dd-MM-yyyy");
        getDACCount({ startTs: startDate, endTs: endDate }, () => setShowDACData(true));
    };

    return (
        <Box sx={{ width: "100%", minWidth: 0 }}>
            <Paper sx={{ p: 2, boxShadow: 2, borderRadius: 1, mb: 2 }}>
                <Alert />
                <Box sx={{ display: "flex", flexDirection: { xs: "column", sm: "row" }, flexWrap: "wrap", alignItems: { xs: "stretch", sm: "flex-end" }, gap: { xs: 1.5, sm: 2 } }}>
                    <Box sx={{ ...fieldWrapperSx, width: { xs: "100%", sm: "auto" } }}>
                        <LabelText sx={labelTopSx}>From:</LabelText>
                        <Box sx={{ minWidth: 140, maxWidth: { xs: "100%", sm: 200 }, width: { xs: "100%", sm: "auto" } }}>
                            <MuiDatePicker
                                label="Start Date"
                                value={startDateFilter ? new Date(startDateFilter) : null}
                                maxDate={new Date()}
                                onChange={handleStartDateChange}
                            />
                        </Box>
                    </Box>
                    <Box sx={{ ...fieldWrapperSx, width: { xs: "100%", sm: "auto" } }}>
                        <LabelText sx={labelTopSx}>To:</LabelText>
                        <Box sx={{ minWidth: 140, maxWidth: { xs: "100%", sm: 200 }, width: { xs: "100%", sm: "auto" } }}>
                            <MuiDatePicker
                                label="End Date"
                                value={endDateFilter ? new Date(endDateFilter) : null}
                                minDate={startDateFilter ? new Date(startDateFilter) : undefined}
                                maxDate={new Date()}
                                onChange={handleEndDateChange}
                            />
                        </Box>
                    </Box>
                    <Box sx={{ mb: { xs: 0, sm: 2 }, width: { xs: "100%", sm: "auto" } }}>
                        <AppButton
                            variant="primary"
                            size="medium"
                            onClick={filter}
                            disabled={startDateFilter === null || endDateFilter === null}
                            sx={{ minWidth: 80, height: 40, width: { xs: "100%", sm: "auto" } }}
                        >
                            Filter
                        </AppButton>
                    </Box>
                </Box>
            </Paper>

            {showDACData && (
                <Paper sx={{ p: 2, boxShadow: 2, borderRadius: 1 }}>
                    <SectionHeading sx={{ m: 0, mb: 1 }}>
                        DAC Count : {dacData?.hasOwnProperty("count") ? dacData?.count : "-"}
                    </SectionHeading>
                </Paper>
            )}
        </Box>
    );
};

export default DACCount;
